import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppsComponent } from './pages/apps/apps.component';


const routes: Routes = [
  {
    path        : 'auth',
    loadChildren: () => import('../app/pages/authentication/auth.module').then(m => m.AuthModule)
  },
  {
    path        : 'apps',
    component:AppsComponent,
    loadChildren: () => import('../app/pages/apps/apps.module').then(m => m.AppsModule),
  },
  {
    path      : '**',  
    redirectTo: 'apps/dashboard'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
